<template>
  <div
    id="login"
    class="h-100 w-100"
  >
    <div class="img w-100 tc">
      <img
        class="login-logo"
        :src="require('@/assets/soda-black.png')"
        alt=""
      >
    </div>
    <div class="container">
      <h1 class="title tc mt3">Connexion</h1>

      <b-field>
        <label
          for="username"
          class="label"
        >
          <i class='fas fa-user mr2'></i> Utilisateur
        </label>
        <b-input
          v-model="username"
          placeholder="Nom d'utilisateur Soda"
        ></b-input>
      </b-field>
      <b-field>
        <label
          for="password"
          class="label"
        >
          <i class='fas fa-key mr2'></i> Mot de passe
        </label>
        <b-input
          v-model="password"
          placeholder="Mot de passe"
          password-reveal
          type="password"
          @keyup.native.enter="login"
        ></b-input>
      </b-field>
      <div class="w-100 tc">
        <button
          class="button is-primary"
          v-on:click="login()"
        >Se connecter
        </button>
        <b-loading
          :is-full-page="isFullPage"
          :active.sync="isLoading"
          :can-cancel="true"
        ></b-loading>
      </div>
    </div>

  </div>
</template>

<script>
import http from "@/modules/request";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      isLoading: false,
      isFullPage: false
    };
  },
  created: function() {
    if (localStorage.getItem("access_token")) {
      localStorage.removeItem("access_token");
      this.$toast.open({
        duration: 2000,
        message: "Vous avez été déconnecté",
        position: "is-top",
        type: "is-warning"
      });
    }

    if (this.$route.query.authorized) {
      this.$toast.open({
        duration: 2000,
        message: "Vous n'êtes pas autorisé à accéder à cette page.",
        position: "is-top",
        type: "is-danger"
      });
      this.$router.push({ name: this.$route.name });
    }
  },
  mounted() {
    this.$parent.$refs.menubar.login = true;
  },
  methods: {
    login() {
      // If form is not blank
      if (
        this.username.replace(/\s/g, "") &&
        this.password.replace(/\s/g, "")
      ) {
        this.isLoading = true;
        http
          .post("/login", {
            username: this.username,
            password: this.password
          })
          .then(res => {
            //Display menu
            this.$parent.$refs.menubar.login = false;
            this.$store.commit("login", res.data);
            this.$router.push({
              name: "dashboard"
            });
          })
          .catch(err => {
            this.isLoading = false;
            this.$toast.open({
              duration: 2000,
              message: "Identifiants incorrectes",
              position: "is-top",
              type: "is-danger"
            });
          });
      }
    }
  }
};
</script>

<style scoped lang="less">
// Phone SIZE
@media screen and (max-width: 768px) {
  .field {
    margin-bottom: 40px;
  }
  .container {
    margin-left: auto !important;
  }
}
.container {
  margin: auto;
  width: fit-content;
  background-color: rgba(42, 163, 214, 0.2);
  border-radius: 10px;
  padding: 1em 4em 1em 4em;
}
.field {
  flex-direction: column;
  margin-top: 10px;
}

.login-logo {
  width: 200px;
}
</style>